/**
 * Gemeinsame Freigabelogik für Immobilien aus Google Sheets.
 * Ein Objekt ist nur öffentlich, wenn es aktiv zur Veröffentlichung freigegeben
 * und sein Online-Status ausdrücklich auf Online oder Verkauft gesetzt ist.
 */
function normalized(value: string | undefined): string {
  return (value ?? "").trim().toLocaleLowerCase("de-DE");
}

export function isPublishedProperty(
  goStatus: string | undefined,
  releaseStatus: string | undefined,
  onlineStatus: string | undefined,
): boolean {
  const hasRelease = normalized(goStatus) === "go" && normalized(releaseStatus) === "ja";
  const publicationState = normalized(onlineStatus);
  return hasRelease && (publicationState === "online" || publicationState === "verkauft");
}

export function isIndexableProperty(
  goStatus: string | undefined,
  releaseStatus: string | undefined,
  onlineStatus: string | undefined,
): boolean {
  return isPublishedProperty(goStatus, releaseStatus, onlineStatus)
    && normalized(onlineStatus) === "online";
}
